import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Grid2,
  Paper,
} from "@mui/material";
import * as React from "react";
import examDate from "../images/date_exam.png";
import logo from "../images/logo_DLS2.png";
import Typography from "@mui/material/Typography";
import Tests from "../components/Tests";
import Niveles from "../components/Niveles";
import { Helmet } from "react-helmet-async";

function Calendario() {
  return (
    <>
      <Helmet>
        <title> DLS - Calendario</title>

        <meta
          name="description"
          content="Estamos en los 3 departamentos La Paz, Cochabamba y Santa Cruz."
        />
        <meta
          name="keywords"
          content="direccion, bolivia, La Paz, Cochabamba, Santa Cruz, traductor, traduccion, cursos, examenes"
        />
        <meta name="author" content="DLS" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <link rel="icon" href="/favicon.ico" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Vea las fechas disponibles" />
        <meta
          property="og:description"
          content="Digital Language Services es un Centro de Idiomas con 22 años de experiencia en la enseñanza de inglés, incluyendo cursos de preparación para exámenes TOEFL iBT e IELTS."
        />
        <meta
          property="og:image"
          content="https://dls.com.bo/static/media/logo_DLS.6424b652d76d8584dbc3.png"
        />
        <meta property="og:url" content="http://localhost:3000/#/calendario" />

        <link rel="canonical" href="https://dls.com.bo" />
      </Helmet>
      <div
        style={{
          maxWidth: "auto",
          display: "block",
          textAlign: "justify",
        }}
      >
        <Box>
          <Grid2 container>
            <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  background: "#009999",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={examDate}
                  alt="Digital Language Services"
                  className="animate__animated animate__fadeInLeft img-dim-banner"
                />
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  background: "#009999",
                  display: "flex",
                  width: "100%",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    background: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    padding: "20px 0",
                    clipPath: {
                      xs: "none",
                      sm: "none",
                      md: "polygon(10% 0, 100% 0, 100% 100%, 0% 100%)",
                    },
                  }}
                >
                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: {
                        xs: "25px",
                        sm: "35px",
                        md: "30px",
                      },
                      color: "#009999",
                      fontWeight: "bold",
                    }}
                  >
                    FECHAS PARA EL 2025
                  </Typography>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
        <Box
          sx={{
            width: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "2px",
          }}
        >
          <Box
            sx={{
              maxWidth: {
                xs: "98vw",
                sm: "90vw",
                md: "70vw",
              },
              display: "block",
              padding: "2px",
            }}
          >
            <Box sx={{ padding: "20px 0" }}>
              <Typography
                variant="h1"
                sx={{ fontSize: "36px", padding: "0 0 15px 0" }}
              >
                TOEFL TEST TEACHING CENTER
              </Typography>
              <Tests />
            </Box>
          </Box>
        </Box>
      </div>
    </>
  );
}

export default Calendario;
